import React, { Component } from 'react';
import { Container } from 'flux/utils';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import InfoCard from '../../components/InfoCard/InfoCard.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import ConfirmButton from '../../components/ConfirmButton/ConfirmButton.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInEmpRecord extends Component {
    static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
    constructor(props){
        super(props);

        RepairClockInDataUtils.empRciApplyRecord(this.props.routeParams.id);
    }
    render(){
        const {
			empRciRecord = {},
			status = 'loading'
		} = this.state,
		{
			baseInfo = {title: ''},
			appInfo = {title: ''}
		} = empRciRecord;

		let appItems = [];
		if(appInfo != undefined && appInfo.items != undefined){
			appItems = appInfo.items[0];
		}
        //console.log(appInfo.items);

        return (<div><Header goBack title={getLang('MY_RCI')} />
                <div><h2 className="info-card-heading gap-b">{baseInfo.title}</h2>
					<InfoCard items={baseInfo.items} />
				</div>
                <div><h2 className="info-card-heading gap-b">{appInfo.title}</h2>
					<InfoCard items={appItems} />
                    {/*<ConfirmButton text={getLang('REVOKE')} onTouchTap={this.revoke} />*/}
				</div>
        </div>);
    }
}

export default Container.create(RepairClockInEmpRecord);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpRecordContainer.js